import { createStyles } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {
      '&.with-icon-style': {
        display: 'flex',
        gap: 16,
        [theme.fn.smallerThan('sm')]: {
          gap: 8,
          flexDirection: 'column',
        },
        '.inner': {
          display: 'flex',
          gap: 16,
          alignItems: 'flex-start',
          [theme.fn.smallerThan('sm')]: {
            alignItems: 'center',
          },
        },
        '.info': {
          display: 'flex',
          flexDirection: 'column',
          gap: 4,
          [theme.fn.largerThan('sm')]: {
            '&.no-desc': {
              minHeight: 80,
              justifyContent: 'center',
            },
          },
        },
        '.desc-mobile': {
          [theme.fn.largerThan('sm')]: {
            display: 'none',
          },
        },
        '.desc-desktop': {
          [theme.fn.smallerThan('sm')]: {
            display: 'none',
          },
        },
        '.icon': { flexGrow: 0 },
        '.icon-wrapper': {
          background: '#fff',
          borderRadius: '100%',
          border: `1px solid ${theme.colors.neutral[1]}`,
          img: {
            maxWidth: '80%',
          },
        },
      },
    },
  }
})
